
export default function Support() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="support" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="w-24 h-24 mx-auto mb-8 bg-gradient-to-br from-purple-600 to-blue-600 rounded-3xl flex items-center justify-center">
          <i className="ri-customer-service-2-line text-white text-5xl w-12 h-12 flex items-center justify-center"></i>
        </div>

        <h2 className="text-5xl font-bold text-gray-900 mb-6">24/7 Support Available</h2>
        <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto leading-relaxed">
          Our dedicated support team is always ready to assist you. Whether you have questions about setup, troubleshooting, or general inquiries, we're here to help.
        </p>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all">
            <div className="w-16 h-16 mx-auto mb-4 bg-purple-100 rounded-xl flex items-center justify-center">
              <i className="ri-chat-3-line text-purple-600 text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Live Chat</h3>
            <p className="text-gray-600 text-sm">
              Get instant answers through our live chat support available 24/7
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all">
            <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-xl flex items-center justify-center">
              <i className="ri-mail-send-line text-blue-600 text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Email Support</h3>
            <p className="text-gray-600 text-sm">
              Send us detailed inquiries and receive comprehensive responses
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-all">
            <div className="w-16 h-16 mx-auto mb-4 bg-green-100 rounded-xl flex items-center justify-center">
              <i className="ri-phone-line text-green-600 text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Phone Support</h3>
            <p className="text-gray-600 text-sm">
              Speak directly with our support specialists for immediate assistance
            </p>
          </div>
        </div>

        <button
          onClick={() => scrollToSection('contact')}
          className="px-10 py-4 bg-black text-white rounded-full font-medium hover:bg-gray-900 transition-all inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer"
        >
          <span>Contact Support</span>
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </button>
      </div>
    </section>
  );
}
